import { Message } from 'shared/domains/common-ui';
export function UserMessage(props) {
    const { message } = props;
    const { text = '' } = message;
    // Remove clauses from message displayed to end-user
    const parsedText = text === null || text === void 0 ? void 0 : text.replaceAll(/<clause>[\s\S]*?<\/clause>/g, '');
    const parsedMessage = Object.assign(Object.assign({}, message), { text: parsedText });
    return <Message message={parsedMessage} align="right" appearance="primary"/>;
}
